export function daysBetweenDates(startDateStr, endDateStr) {
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);

  // Difference in milliseconds
  const diffMs = end - start;

  // Convert to days
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}
